<template>
  <div>{{ data.text }}</div>
  <v-row>
    <v-col v-for="(radio, index) in data.props" :key="index" cols="12" md="4">
      <v-radio-group :name="data.name" v-model="value.check" class="flex-center">
        <v-radio :label="radio.text" :value="radio.name"></v-radio>
      </v-radio-group>

    </v-col>
  </v-row>

  <v-row>
    <v-col v-for="(element, index) in data.props" :key="index" cols="12" md="4">
      <v-text-field v-model="value[element.name]" :placeholder="`${data.props[index].text}`"></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CheckboxWithTextComponent',
  props: {
    data: Object,
    baseValue: [Object, String, Array, Boolean],
  },
  data: (props) => {
    return {
      value: props.baseValue ?? {},
    }
  },
  emits: ['formModEvent'],
  watch: {
    value() {
      this.sendDataToParent()
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = [
        {
          key: this.data.name,
          value: this.value,
        },
      ]
      this.$emit('formModEvent', dataToSend)
    },
  },
})
</script>

<style lang="css" scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
